import Marquee from "react-fast-marquee";
import { Heart } from "lucide-react";

const words = ["Helfen.", "Hoffen.", "Chancen schenken."];

export const MarqueeBand = () => {
  return (
    <section
      className="relative overflow-hidden bg-gradient-to-r from-violet via-magenta to-violet py-14 sm:py-20"
      data-testid="marquee-section"
    >
      <Marquee speed={55} gradient={false} autoFill>
        <div className="flex items-center">
          {words.map((w, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display italic text-white text-5xl sm:text-7xl lg:text-8xl tracking-tight px-8">
                {w}
              </span>
              <Heart className="mx-4 shrink-0 text-white/70" size={34} />
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
};
